const shanxinApp = [
    //-------------------新闪信app--------------------------------------

    {
      path: '/app/form-info-app',
      component: () => import('@/pages/app/form-info-app.vue'),
      meta: {
        title: '个人信息',
        keepAlive: true
      }
    },
    {
      path: '/app/add-info-app',
      component: () => import('@/pages/app/add-info-app.vue'),
      meta: {
        title: '联系人信息',
        keepAlive: true
      }
    },
    {
      path: '/app/exam-loading',
      component: () => import('@/pages/app/exam-loading.vue'),
      meta: {
        title: '申请中',
        keepAlive: true
      }
    },

    //A面加载中。。
    {
      path: '/app/exam-loading-f',
      component: () => import('@/pages/app/exam-loading-f.vue'),
      meta: {
        title: '申请中',
        keepAlive: false
      }
    },
    {
      path: '/app/result-page',
      component: () => import('@/pages/app/result-page.vue'),
      meta: {
        title: '',
        keepAlive: false
      }
    },

    {
      path: '/app/agreement',
      component: () => import('@/pages/app/agreement.vue'),
      meta: {
        title: '协议',
        keepAlive: true
      }
    },
    
  ]
  export default shanxinApp
  


// WEBPACK FOOTER //
// ./src/router/modules/shanxin-app.js